import { render, staticRenderFns } from "./SaleOrderService.vue?vue&type=template&id=cdc4a27a&"
import script from "./SaleOrderService.vue?vue&type=script&lang=js&"
export * from "./SaleOrderService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports